export type NotFoundMock = {
    title: string;
    message: string;
    homeButtonLabel: string;
};

export const notFoundMock: NotFoundMock = {
    title: '404',
    message: 'Page not found',
    homeButtonLabel: 'Back to home',
};
